import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../feedback/ConfirmDialog";

const ConfirmDeleteBowler = ({
  show,
  onHide,
  confirmDescription,
  confirmButtonText,
  onConfirmClick,
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      show={show}
      onHide={onHide}
      description={t(
        confirmDescription || "message.confirm.confirmDeleteBowler",
      )}
      confirmText={t(confirmButtonText || "message.confirm.deleteBowler")}
      onConfirm={onConfirmClick}
    />
  );
};

export default ConfirmDeleteBowler;
